import * as Radix from "@radix-ui/react-popover";

const Content = (props: Radix.PopoverContentProps): JSX.Element => {
    return (
        <Radix.Portal>
            <Radix.Content
                className={[
                    //
                    "rounded",
                    "bg-[var(--diagram-table-bg)] shadow-24 rounded-md z-[5] border border-[var(--diagram-control-border)]",
                ].join(" ")}
                {...props}
            />
        </Radix.Portal>
    );
};

const Arrow = (props: Radix.PopoverArrowProps): JSX.Element => {
    return (
        <Radix.Arrow
            className={["fill-[var(--diagram-table-bg)] shadow-lg"].join(" ")}
            {...props}
        />
    );
};

export const Popover = {
    Root: Radix.Root,
    Trigger: Radix.Trigger,
    Content,
    Arrow,
};
